export enum ViewSchemaType {
  Image = 'image',
  TileImage = 'tile-image',
  Vector = 'vector',
  None = 'none'
}
